import React, { useState, useEffect } from 'react';
import Media from '../../../../../modules/react/editors/ImageWidget/Media';

const ImageSettingEditor = ({ input: { onChange }, data,
  loading, onUpload, showGallery, setShowGallery, usedMedia, setUsedMedia, images = [], setImages }) => {
  const [selectedMedium, setSelectedMedium] = useState();
  const [initialValues, setInitialValues] = useState(images);
  const [error, setError] = useState();

  useEffect(() => {
    if (data && data.mediumUpload.medium) {
      setImages([...images, {
        ...data.mediumUpload.medium,
        mediumId: data.mediumUpload.medium.id,
      }]);
      onChange([...images, {
        ...data.mediumUpload.medium,
        mediumId: data.mediumUpload.medium.id,
      }]);
    } else if (data && data.mediumUpload.userErrors.length) {
      setError(data.mediumUpload.userErrors.map(err => err.message));
    }
  }, [data]);

  useEffect(() => {
    setError();
    const media = images && images.filter(image => image.mediumId).map(image => image.mediumId);
    setUsedMedia(media);
  }, [images]);

  const changeValue = (index, valueName, value) => {
    const newImages = [...images];
    newImages[index][valueName] = value;
    setImages(newImages);
    onChange(newImages);

    const modifiedImage = newImages[index];
    const unmodified = initialValues.some(val => val.mediumId !== modifiedImage.mediumId);
    if (unmodified) { setInitialValues(prevValues => [...prevValues, modifiedImage]); }
  };

  const handleAltChange = index => ({ target }) => {
    changeValue(index, 'alt', target.value);
  };

  const handleTitleChange = index => ({ target }) => {
    changeValue(index, 'title', target.value);
  };

  const handleDelete = index => () => {
    const newImages = [...images];
    const removedImage = newImages.splice(index, 1);
    setImages(newImages);
    onChange(newImages);

    if (removedImage) {
      const modifiedIndex = initialValues.findIndex(val => val.mediumId === removedImage.mediumId);
      const newInitialValues = [...initialValues];
      if (modifiedIndex > -1) {
        newInitialValues.splice(modifiedIndex, 1); setInitialValues(newInitialValues);
      }
    }
  };

  const handleMove = (index, modifier) => () => {
    const newImages = [...images];
    newImages.splice(index + modifier, 0, newImages.splice(index, 1)[0]);
    setImages(newImages);
    onChange(newImages);
  };

  return <Media
    error={error}
    handleAltChange={handleAltChange}
    handleDelete={handleDelete}
    handleMove={handleMove}
    handleTitleChange={handleTitleChange}
    images={images}
    loading={loading}
    onUpload={onUpload}
    selectedMedium={selectedMedium}
    setImages={setImages}
    setSelectedMedium={setSelectedMedium}
    setShowGallery={setShowGallery}
    showGallery={showGallery}
    usedMedia={usedMedia}
    isBackgroundEditor
  />;
};

export default ImageSettingEditor;
